export default __webpack_public_path__ + "static/media/default.61fbf79c8be4d83e32b3e0f1ed9878fd.png";